<!-- 我要回答 -->
<template>
    <div>
      <div class="course_answer">
        <el-row class="content_block">
          <el-row>
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column type="index" header-align="center" align="center" width="100" label="序号"></el-table-column>
              <el-table-column prop="teacherOpenCourseChatLogAddTime" header-align="center" align="center" label="提问时间" width="200"> </el-table-column>
              <el-table-column prop="studentIdText" header-align="center" align="center" label="提问学生" width="200"> </el-table-column>
              <el-table-column prop="chatLogSendTypeText" header-align="center" align="center" label="提问方式" width="200"> </el-table-column>
              <el-table-column prop="chatContent" header-align="center" align="center" label="提问内容" >
                <template slot-scope="scope">
                  <el-row v-html="scope.row.chatContent"></el-row>
                </template>
              </el-table-column>
              <el-table-column prop="wdhd" header-align="center" align="center" label="我的回答" width="200">
                <template slot-scope="scope">
                  <el-row v-html="scope.row.replyContent"></el-row>
                </template>
              </el-table-column>
              <el-table-column prop="studentScore" header-align="center" align="center" label="我的得分" width="120"> </el-table-column>
              <el-table-column prop="messageAcceptState" header-align="center" align="center" label="操作" width="180">
                <template slot-scope="scope">
                  <el-link type="primary" :underline="false" @click="lookReply(scope.row)">回答</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-sizes="[8, 20, 50, 100]"
                :page-size="limit"
                background
                :hide-on-single-page="true"
                layout="sizes, prev, pager, next,jumper"
                :total="total">
              </el-pagination>
            </div>
          </el-row>
        </el-row>

        <!-- 提问对话框 -->
        <el-dialog
          title="我要回答"
          :visible.sync="user_questions_show"
          width="800px"
        >
          <el-row class="mb40">
            <el-col :span="3">问题摘要：</el-col>
            <el-col :span="21" class="user_questions">
              <el-row v-html="questionsInfo.chatContent"></el-row>
            </el-col>
          </el-row>
          <el-row class="mb40">
            <RichText ref="richText" v-if="user_questions_show" v-model="questionsInfo.forest_desc" />
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="user_questions_show = false">取 消</el-button>
            <el-button type="primary" @click="submitInfo">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import RichText from '@/components/RichText/index';

export default {
  name: 'Answer',
  components: {
    RichText
  },
  props: {
    courseId: { //课程ID
      type: String,
      required: true
    }
  },
  data() {
    return {
      options: [
      {
        value: '',
        label: '全部'
      },{
        value: '选项1',
        label: '已回答'
      }, {
        value: '选项2',
        label: '待回答'
      }],
      value: '',
      searchInfo:"",
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      user_questions_show:false,
      questionsInfo:{},
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    getInfo(){ //获取数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseId:this.courseId,
        chatLogSendTypePlural:"specify_ask,random_ask",
        studentId:this.$ls.get(this.$getKeyInfo("identityInfo")).studentId, //学生ID
      }
      this.$post("/api/teacherOpenCourseChatLog/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    lookReply(item){ //查看回复
      this.questionsInfo = {};
      this.questionsInfo.chatContent = item.chatContent;
      this.questionsInfo.teacherOpenCourseChatLogParentId = item.teacherOpenCourseChatLogId;
      this.user_questions_show = true;
    },
    submitInfo(){ //打开提问对话框
      if(this.$isEmpty(this.questionsInfo.forest_desc)){
        this.$message({message: '请输入回复内容！',type: 'warning'});
        return;
      }
      let param = {
        teacherOpenCourseId:this.courseId,
        chatContent:this.questionsInfo.forest_desc,
        teacherOpenCourseChatLogParentId:this.questionsInfo.teacherOpenCourseChatLogParentId,
      }
      this.$postJSON("/api/teacherOpenCourseChatLog/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.getInfo();
          this.user_questions_show = false;
          this.$message({message: '提交成功！',type: 'success'});
          this.$emit("onSuccess_t");
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_answer{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .content_block{
      background-color: #ffffff;
      .title_img{
        width: 20px;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
      .block_time{
        display: initial;
        margin-left: 20px;
      }
      .el-calendar__body{
        th{
          border-top: 1px solid #E5E5E5;
          border-left: 1px solid #E5E5E5;
          background-color: #EFF2F7;
        }
        th:last-child{
          border-right: 1px solid #E5E5E5;
        }
      }
    }
    .user_questions{
      p{
        margin: 0;
        padding: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/course/components/interaction/Answer.vue